import loadable from 'react-loadable'

import i18n from '@signavio/i18n'

import { createLoadingMessage } from '@signavio/effektif-commons'

export * from './utils'

export const Login = loadable({
  loader: () => import(/* webpackChunkName: "login" */ './Login'),
  loading: createLoadingMessage(() => ({
    loading: i18n('Preparing login...'),
  })),
})

export const Registration = loadable({
  loader: () => import(/* webpackChunkName: "registration" */ './Registration'),
  loading: createLoadingMessage(() => ({
    loading: i18n('Preparing registration...'),
  })),
})

export const ForgotPassword = loadable({
  loader: () =>
    import(/* webpackChunkName: "forgotPassword" */ './forgotPassword'),
  loading: createLoadingMessage(() => ({
    loading: i18n('Preparing password recovery...'),
  })),
})
